/**
 * Table Cell Icons
 * Replaces table cell content based on cell content.
 * @author Rhys Lloyd
 */

import $ from "jquery";
import debug from 'debug';
const log = debug('core/components/wysiwyg/table-cell-icons');

// Constants
const TABLE_DATA_ATTRIBUTE = 'data-table-icons';
const TABLE_IGNORE = 'ignore';
const ICON_KEYWORDS = ['yes', 'restricted', 'no'];
const ICON_BRACKET_OPEN = '[';
const ICON_BRACKET_CLOSE = ']';
const KEYWORD_ICON = {
	'yes': 'covered',
	'restricted': 'restricted',
	'no': 'excluded'
};

function getIconClassString(keyword) {
	return `icon--${keyword}`;
}

function keywordFormatter(keyword) {
	return `${ICON_BRACKET_OPEN}${keyword}${ICON_BRACKET_CLOSE}`;
}

//noinspection SpellCheckingInspection
function keywordUnformatter(keyword) {
	return keyword.substring(ICON_BRACKET_OPEN.length, keyword.length - ICON_BRACKET_CLOSE.length);
}

function iconLookup(keyword) {
	return KEYWORD_ICON[keyword] || keyword;
}

/**
 * Run plugin
 */
function exec () {
	log('Running...');

	// Find tables
	let $tables = $('table').filter(`:not([${TABLE_DATA_ATTRIBUTE}="${TABLE_IGNORE}"])`);

	if (!$tables.length) {
		log('No tables to parse.');
		return;
	}

	// Add data attribute - in progress value
	$tables.attr(TABLE_DATA_ATTRIBUTE, 'in-progress');
	log('Parsing tables', $tables);

	// Cell icon template
	let $labelTemplate = $('<span>').addClass('icon__label u-visually-hidden'),
		$iconTemplate = $('<i>').addClass('icon');

	// Match replacer - nested function for closure access to $iconTemplate
	function keywordReplacer(match) {
		const keyword = keywordUnformatter(match),
			iconName = iconLookup(keyword),
			$label = $labelTemplate.clone().text(keyword);

		return $iconTemplate.clone()
			.addClass(getIconClassString(iconName))
			.addClass(`keyword-icon keyword-icon--${keyword}`)
			.append($label)
			.prop('outerHTML');
	}

	// Loop through all TD cells
	$tables.find('td').each(function () {
		let $this = $(this);

		// For each keyword, loop through cell contents and replace
		// keyword with icon template
		for (let keyword of ICON_KEYWORDS) {
			let original = $this.html(),
				updated = original.replace(keywordFormatter(keyword), keywordReplacer);

			if (original !== updated) {
				log('Replacing cell contents:\nOriginal:', original, '\nUpdated:', updated);
				$this.html(updated);
			}
		}
	});

	// Set data attribute to indicate done
	$tables.attr(TABLE_DATA_ATTRIBUTE, true);
}

exec();



// WEBPACK FOOTER //
// ./project/client/src/core/components/wysiwyg/table-cell-icons.js